module.exports = __webpack_public_path__ + "img/create-free-account.dd22aaa6.png";